export default __webpack_public_path__ + "static/media/broadway-roulette-logo.622611d4.png";